// tempexp_SRCH-70119-full-file
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IPromoData } from 'reactApp/modules/promo/promo.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { sendDwh } from 'reactApp/utils/ga';

import { searchTooltipData, SearchTooltipTypes } from './SearchTooltip.data';
import {
    getSessionTooltipVisibilityStatus,
    getTooltipAppearanceCount,
    getTooltipFlagName,
    increaseTooltipAppearanceCount,
    setSessionTooltipVisibilityStatus,
} from './SearchTooltip.helpers';

interface UseTooltipStateProps {
    visibilityValue: boolean;
    tooltipType: SearchTooltipTypes | null;
    promo: IPromoData | undefined;
}

export const useTooltipState = ({ visibilityValue, tooltipType, promo }: UseTooltipStateProps) => {
    const email = useSelector(UserSelectors.getEmail);
    const tooltipFlagName = getTooltipFlagName(email, tooltipType);
    const data = tooltipType ? searchTooltipData[tooltipType] : { title: '', description: '' };

    const sendRadar = (eventCategory) => {
        sendDwh({
            eventCategory,
            dwhData: {
                place: 'desktop',
                text_id: tooltipType,
                text: `${data.title} ${data.description}`,
            },
        });
    };

    const [isTooltipVisible, setTooltipVisibility] = useState(
        promo &&
            tooltipFlagName &&
            visibilityValue &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true' &&
            (getTooltipAppearanceCount(tooltipFlagName) < 1 || getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true')
    );

    useEffect(() => {
        if (
            promo &&
            tooltipType &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true' &&
            (getTooltipAppearanceCount(tooltipFlagName) < 1 || getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true')
        ) {
            setTooltipVisibility(visibilityValue);
        }
    }, [visibilityValue, promo]);

    useEffect(() => {
        if (isTooltipVisible) {
            sendRadar('search-tooltip-show');
            promo?.onShow();
            if (getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') !== 'true') {
                setSessionTooltipVisibilityStatus(tooltipFlagName, 'visible');
                increaseTooltipAppearanceCount(tooltipFlagName);
            }
        }
    }, [isTooltipVisible]);

    const onTooltipClose = useCallback(() => {
        if (
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'visible') === 'true' &&
            getSessionTooltipVisibilityStatus(tooltipFlagName, 'closed') !== 'true'
        ) {
            setTooltipVisibility(false);
            promo?.onClose();
            sendRadar('search-tooltip-close');
            setSessionTooltipVisibilityStatus(tooltipFlagName, 'closed');
        }
    }, [promo]);

    return { isTooltipVisible, onTooltipClose };
};
